if (!customElements.get('dbtfy-product-sharing')) {
  customElements.define(
    'dbtfy-product-sharing',
    class DbtfyProductSharing extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      init() {
        const dbtfyProductSharingHTML = document.querySelector('.dbtfy-product-sharing-block');

        if (!dbtfyProductSharingHTML) return;

        const productElement = this.querySelector('[data-product-sharing-product]');
        if (!productElement) return;

        this.data = Debutify.widgets['product_sharing'];

        this.product = JSON.parse(productElement.innerHTML);
        this.collections = JSON.parse(this.querySelector('[data-product-sharing-collection]').innerHTML);

        this.visibleBreaks = [];

        const visible = this.getVisibleBreaks();
        if (!visible) {
          this.remove();
          return;
        }

        this.innerHTML = Debutify.replaceVariables(dbtfyProductSharingHTML.innerHTML, {
          share_permalink: this.dataset.sharePermalink,
          share_image: this.dataset.shareImage,
          share_title: this.dataset.shareTitle,
          share_description: this.dataset.shareDescription,
          share_content: this.dataset.shareContent,
          share_title_escaped: this.dataset.shareTitleEscaped,
          share_description_escaped: this.dataset.shareDescriptionEscaped,
          share_content_escaped: this.dataset.shareContentEscaped,
        });

        this.classList.remove('hidden');

        this.button = this.querySelector('.social-sharing-button-icon');
        this.icon = this.querySelector('.social-sharing-icons');

        if (!this.button || !this.icon) return;

        const screenWidth = window.innerWidth;
        if (screenWidth <= 768) {
          this.modalshow();
        } else {
          this.handleTooltip();
        }
      }

      getVisibleBreaks() {
        const collection_handles = this.collections.map((collection) => collection.handle);

        const settings = this.data[0];

        switch (settings.visibility) {
          case 'collection':
            return collection_handles.includes(settings.collection);
          case 'type':
            return settings.types.toLowerCase().includes(this.product.type.toLowerCase());
          case 'tag':
            return this.product.tags.some((tag) => settings.tags.toLowerCase().includes(tag.toLowerCase()));
          case 'product':
            return settings.product === this.product.handle;
          case 'all':
            return true;
          default:
            return false;
        }
      }

      handleTooltip() {
        const { computePosition, offset, flip } = window.FloatingUIDOM;

        const update = () => {
          computePosition(this.button, this.icon, {
            placement: 'top-start',
            middleware: [offset(10), flip()],
          }).then(({ x, y }) => {
            Object.assign(this.icon.style, {
              position: 'absolute',
              left: `${x}px`,
              top: `${y}px`,
            });
          });
        };

        const showTooltip = () => {
          this.icon.classList.add('show');
          document.body.classList.add('dbtfy-product-sharing-tooltip');
          update();
        };

        const hideTooltip = () => {
          setTimeout(() => {
            this.icon.classList.remove('show');
            this.icon.classList.add('hiding');
            setTimeout(() => {
              this.icon.classList.remove('hiding');
            }, 200);
            document.body.classList.remove('dbtfy-product-sharing-tooltip');
          }, 100);
        };

        this._listeners = [];

        const addListeners = (events) => {
          events.forEach(([event, listener]) => {
            this.button.addEventListener(event, listener);
            this._listeners.push([event, listener]);
          });
        };

        if (window.matchMedia('(pointer: coarse)').matches) {
          addListeners([
            ['mouseenter', showTooltip],
            ['mouseleave', hideTooltip],
            ['focus', showTooltip],
            ['blur', hideTooltip],
          ]);
        } else {
          addListeners([
            ['focus', showTooltip],
            ['blur', hideTooltip],
          ]);
        }
      }

      modalshow() {
        const wrapper = document.createElement('div');
        wrapper.classList.add('dbtfy-product-sharing-wrapper');
        this.icon.parentNode.insertBefore(wrapper, this.icon);
        wrapper.appendChild(this.icon);

        const wrapperIcon = document.createElement('div');
        wrapperIcon.classList.add('dbtfy-social-sharing', 'display_button');
        this.icon.parentNode.insertBefore(wrapperIcon, this.icon);
        wrapperIcon.appendChild(this.icon);

        document.addEventListener('DOMContentLoaded', () => {
          this.modal = new Debutify.modal({
            closeMethods: ['overlay', 'button', 'escape'],
            size: 'medium',
            closeIcon: 'close',
            selector: 'dbtfy-product-sharing .dbtfy-product-sharing-wrapper ',
            boxClass: [],
            overlayClass: [],
          });
        });

        this.button.onclick = () => {
          this.modal.open();
        };
      }
    }
  );
}
